module.exports = __webpack_public_path__ + "media/img/pages/profile/vaudoise ger 5-246102633e6ea51f8dc31eba030bdde0.jpg";